export default {
  header: 'Roboto, sans-serif',
  paragraph: 'Raleway, sans-serif',
}



// WEBPACK FOOTER //
// ./src/styles/fonts.js